import gql from 'graphql-tag';

export const TAG_TYPE = gql`
  fragment TagType on TagType {
    id
    name
    description
  }
`;
